<div>
  <ng-content></ng-content>

  <!-- 
  having 2 anchors to solve an edge case when the loaded data is very small and the early anchor is out of view
  and also as a safe guard if the lazy loading anchor didn't trigger for any reason (like rapid scrolling for example) 
  -->
  <div #earlyLoadingAnchor class="early-loading-anchor" *ngIf="!stopObserving"></div>
  <div #lazyLoadingAnchor class="lazy-loading-anchor" *ngIf="!stopObserving"></div>
</div>
